// extracted by mini-css-extract-plugin
module.exports = {"root":"StockChart_root__ofBeK","notice":"StockChart_notice__rTeJs","shell":"StockChart_shell__Vle9e","canvas":"StockChart_canvas___haEZ","loading":"StockChart_loading__uEqzX"};